<h1 mat-dialog-title class="dialog-title">{{'modal.matrix.title' | transloco}}</h1>
<div mat-dialog-content class="dialog-content">
  <p class="dialog-content-text">{{ getDeleteMessage() }}</p>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button (click)="onNoClick()" class="dialog-button cancel-button">{{'modal.matrix.cancel' | transloco}}</button>
  <span></span>
  <button (click)="onDeleteClick()" class="dialog-button delete-button">{{'modal.matrix.delete' | transloco}}</button>
</div>
